import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { iconFor } from "./iconMap";

interface SelectLinkProps {
  title: string;
  iconKey: string;
  onClick: () => void;
  iconChange: boolean;
  collapsed?: boolean;
}

export default function SelectLink({
  title,
  iconKey,
  onClick,
  iconChange,
  collapsed = false,
}: SelectLinkProps) {
  const Icon = iconFor(iconKey);

  const button = (
    <ListItemButton
      onClick={onClick}
      sx={{
        minHeight: 48,
        justifyContent: collapsed ? "center" : "flex-start",
        px: 2.5,
        color: "var(--gray-100)",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 2,
          justifyContent: "center",
          color: "inherit",
        }}
      >
        <Icon />
      </ListItemIcon>
      {!collapsed && (
        <>
          <ListItemText
            primary={title}
            slotProps={{ primary: { sx: { fontSize: 14 } } }}
          />
          {iconChange ? <ExpandLess /> : <ExpandMore />}
        </>
      )}
    </ListItemButton>
  );

  if (collapsed) {
    return (
      <Tooltip title={title} placement="right" arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
}
